/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * Modified by David Little, 2016
 */

// Countries province label update - vanilla JS
if (typeof Countries === 'object') {
    Countries.updateProvinceLabel = function(countryCode, labelEl) {
        if (typeof countryCode !== 'string' || !Countries[countryCode] || !Countries[countryCode].provinces) return;
        if (typeof labelEl !== 'object') {
            labelEl = document.getElementById('address_province_label');
            if (!labelEl) return;
        }
        labelEl.innerHTML = Countries[countryCode].label;
        var parent = labelEl.parentElement;
        if (parent) {
            var customBox = parent.querySelector('.custom-style-select-box-inner');
            if (customBox) customBox.innerHTML = Countries[countryCode].provinces[0];
        }
    };
}

if (typeof Shopify.Cart === 'undefined') { Shopify.Cart = {}; }

Shopify.Cart.ShippingCalculator = (function() {
    var _config = {
        submitButton: 'Calculate shipping',
        submitButtonDisabled: 'Calculating...',
        templateId: 'shipping-calculator-response-template',
        wrapperId: 'wrapper-response',
        customerIsLoggedIn: false,
        moneyFormat: '${{amount}}'
    };

    function _render(data) {
        var templateEl = document.getElementById(_config.templateId);
        var wrapperEl = document.getElementById(_config.wrapperId);
        if (!templateEl || !wrapperEl) return;

        var template = Handlebars.compile(templateEl.textContent.trim());
        var html = template(data);
        wrapperEl.insertAdjacentHTML('beforeend', html);

        if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
            var currency = '';
            var currencySelect = document.querySelector('[name=currencies]');
            var currencySpan = document.querySelector('#currencies span.selected');
            if (currencySelect) currency = currencySelect.value;
            else if (currencySpan) currency = currencySpan.getAttribute('data-currency');
            if (currency) Currency.convertAll(shopCurrency, currency, '#wrapper-response span.money, #estimated-shipping span.money');
        }
    }

    function _enableButtons() {
        document.querySelectorAll('.get-rates').forEach(function(btn) {
            btn.removeAttribute('disabled');
            btn.classList.remove('disabled');
            btn.value = _config.submitButton;
        });
    }

    function _disableButtons() {
        document.querySelectorAll('.get-rates').forEach(function(btn) {
            btn.value = _config.submitButtonDisabled;
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('disabled');
        });
    }

    function _getCartShippingRatesForDestination(address) {
        var params = new URLSearchParams();
        for (var key in address) {
            params.append('shipping_address[' + key + ']', address[key]);
        }

        fetch('/cart/prepare_shipping_rates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params
        })
        .then(function() {
            _pollForCartShippingRatesForDestination(address)();
        })
        .catch(_onError);
    }

    function _pollForCartShippingRatesForDestination(address) {
        return function poll() {
            fetch('/cart/async_shipping_rates')
                .then(function(response) {
                    if (response.status === 200) {
                        return response.json().then(function(data) {
                            _onCartShippingRatesUpdate(data.shipping_rates, address);
                        });
                    } else {
                        setTimeout(poll, 500);
                    }
                })
                .catch(_onError);
        };
    }

    function _fullMessagesFromErrors(errors) {
        var messages = [];
        for (var field in errors) {
            if (Array.isArray(errors[field])) {
                errors[field].forEach(function(msg) {
                    messages.push(field + ' ' + msg);
                });
            }
        }
        return messages;
    }

    function _onError(error) {
        var estimatedEl = document.getElementById('estimated-shipping');
        if (estimatedEl) {
            estimatedEl.style.display = 'none';
            var em = estimatedEl.querySelector('em');
            if (em) em.innerHTML = '';
        }
        _enableButtons();

        var feedback = '';
        try {
            var data = typeof error === 'string' ? JSON.parse(error) : error;
            feedback = data.message ? data.message + '(' + data.status + '): ' + data.description : 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.';
        } catch (e) {
            feedback = 'An error occurred.';
        }

        if (feedback === 'Error : country is not supported.') {
            feedback = 'We do not ship to this destination.';
        }

        _render({ rates: [], errorFeedback: feedback, success: false });

        var wrapperEl = document.getElementById(_config.wrapperId);
        if (wrapperEl) wrapperEl.style.display = '';
    }

    function _onCartShippingRatesUpdate(rates, address) {
        _enableButtons();

        var addressStr = '';
        if (address.zip) addressStr += address.zip + ', ';
        if (address.province) addressStr += address.province + ', ';
        addressStr += address.country;

        if (rates.length) {
            var estimatedEl = document.getElementById('estimated-shipping');
            if (estimatedEl) {
                var em = estimatedEl.querySelector('em');
                if (em) em.innerHTML = rates[0].price === '0.00' ? 'FREE' : _formatRate(rates[0].price);
            }
            rates.forEach(function(rate) {
                rate.price = _formatRate(rate.price);
            });
        }

        _render({ rates: rates, address: addressStr, success: true });

        var wrapperEl = document.getElementById(_config.wrapperId);
        var estimatedEl = document.getElementById('estimated-shipping');
        if (wrapperEl) wrapperEl.style.display = '';
        if (estimatedEl) estimatedEl.style.display = '';
    }

    function _formatRate(price) {
        if (typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(price, _config.moneyFormat);
        }

        if (typeof price === 'string') price = price.replace('.', '');

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = precision !== undefined ? precision : 2;
            thousands = thousands !== undefined ? thousands : ',';
            decimal = decimal !== undefined ? decimal : '.';

            if (isNaN(number) || number == null) return 0;

            number = (number / 100).toFixed(precision);
            var parts = number.split('.');
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var format = _config.moneyFormat;
        var match = format.match(placeholderRegex);

        if (match) {
            switch (match[1]) {
                case 'amount': value = formatWithDelimiters(price, 2); break;
                case 'amount_no_decimals': value = formatWithDelimiters(price, 0); break;
                case 'amount_with_comma_separator': value = formatWithDelimiters(price, 2, '.', ','); break;
                case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(price, 0, '.', ','); break;
            }
        }

        return format.replace(placeholderRegex, value);
    }

    function _init() {
        new Shopify.CountryProvinceSelector('address_country', 'address_province', { hideElement: 'address_province_container' });

        var countrySelect = document.getElementById('address_country');
        var provinceLabel = document.getElementById('address_province_label');

        if (typeof Countries !== 'undefined' && countrySelect) {
            Countries.updateProvinceLabel(countrySelect.value, provinceLabel);
            countrySelect.addEventListener('change', function() {
                Countries.updateProvinceLabel(countrySelect.value, provinceLabel);
            });
        }

        document.querySelectorAll('.get-rates').forEach(function(btn) {
            btn.addEventListener('click', function() {
                _disableButtons();
                var wrapperEl = document.getElementById(_config.wrapperId);
                if (wrapperEl) {
                    wrapperEl.innerHTML = '';
                    wrapperEl.style.display = 'none';
                }

                var address = {
                    zip: (document.getElementById('address_zip') || {}).value || '',
                    country: (document.getElementById('address_country') || {}).value || '',
                    province: (document.getElementById('address_province') || {}).value || ''
                };

                _getCartShippingRatesForDestination(address);
            });
        });

        if (_config.customerIsLoggedIn) {
            var firstBtn = document.querySelector('.get-rates');
            if (firstBtn) firstBtn.click();
        }
    }

    return {
        show: function(options) {
            options = options || {};
            Object.assign(_config, options);
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', _init);
            } else {
                _init();
            }
        },
        getConfig: function() { return _config; },
        formatRate: function(price) { return _formatRate(price); }
    };
})();
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      if (!this.slider || !this.nextButton) return;
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
      if (this.enableSliderLooping) return;
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;
        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));
        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
        if (!isFirstSlide && !isLastSlide) return;
        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');
        if (!this.sliderControlButtons.length) return;
        this.sliderControlButtons.forEach(link => {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.rendorStickyCart();
            this.updateVariantInput();
            // this.updateURL();
            this.renderProductInfo();
            this.rendorStickyCart();
            if (!document.body.classList.contains('quick-view_popup')) {
              const size = document.getElementById(`MediaGallery-${this.dataset.section}`)
              let sizes = size.getAttribute("product-image");
              if (sizes > 1) {
              this.updateMedia();
             }
            }
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      
      } 

    updateURL() {
        if (document.body.classList.contains('template-product')) {
            if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
            window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
    }

    updateMedia() {
        if (!document.body.classList.contains('quick-view_popup')) {
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;
            const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
            mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
            const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
            if (!modalContent) return;
            const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            modalContent.prepend(newMediaModal);
        }
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}${this.dataset.product}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  
    updatePickupAvailability() {
        if (document.body.classList.contains('template-product')) {
            const pickUpAvailability = document.querySelector('pickup-availability');
            if (!pickUpAvailability) return;
            if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
            }
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.product}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.product}`);
                if (source && destination) destination.innerHTML = source.innerHTML;
                const price = document.getElementById(`price-${this.dataset.product}`);
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}${this.dataset.product}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }
        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}${this.dataset.product}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.product}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    rendorStickyCart() {
        if (document.body.classList.contains('template-product')) {
            const quick = this.closest('#quick-view');
            if (quick == null) {
                fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((responseText) => {
                    const id = `sticky-${this.dataset.section}`;
                    const varName = `#sticky-${this.dataset.section} .sticky-title`;
                    const varHtml = new DOMParser().parseFromString(responseText, 'text/html');
                    const varDestination = document.querySelector(varName);
                    const varSource = varHtml.querySelector(varName);
                    if (varDestination && varSource) varDestination.innerHTML = varSource.innerHTML;

                    // Replace jQuery .load() with fetch
                    fetch(location.href)
                        .then(r => r.text())
                        .then(html => {
                            const doc = new DOMParser().parseFromString(html, 'text/html');
                            const inventoryEl = document.getElementById('ProductForm__Inventory');
                            const inventorySrc = doc.getElementById('ProductForm__Inventory');
                            if (inventoryEl && inventorySrc) inventoryEl.innerHTML = inventorySrc.innerHTML;

                            const addBtns = document.querySelector('.Addbtns');
                            const addBtnsSrc = doc.querySelector('.Addbtns');
                            if (addBtns && addBtnsSrc) addBtns.innerHTML = addBtnsSrc.innerHTML;
                        });

                    const imgName = `#sticky-${this.dataset.section} .sticky-img`;
                    const imgHtml = new DOMParser().parseFromString(responseText, 'text/html')
                    const imgSource = imgHtml.querySelector(imgName);
                    const stickyImg = document.querySelector('.sticky-img');
                    if (stickyImg && imgSource) stickyImg.replaceWith(imgSource);

                    const options = `#sticky-${this.dataset.section} .stickyOptions`;
                    const html = new DOMParser().parseFromString(responseText, 'text/html')
                    const destination = document.querySelector(options);
                    const source = html.querySelector(options);
                    if (destination && source) destination.innerHTML = source.innerHTML;

                    const idName = `#sticky-${this.dataset.section} .sticky-id`;
                    const idHtml = new DOMParser().parseFromString(responseText, 'text/html')
                    const idSource = idHtml.querySelector(idName);
                    const stickyId = document.querySelector('.sticky-id');
                    if (stickyId && idSource) stickyId.replaceWith(idSource);
                });
            }
        }
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

document.addEventListener('DOMContentLoaded', function() {
    const currencySelect = document.querySelector('#currency_form select');
    if (currencySelect) {
        currencySelect.addEventListener('change', function() {
            document.getElementById('currency_form').submit();
        });
    }
});

/*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
  
      this.calculateSizes();
  
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);
  
      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);
  
      // window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));
  
      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
      this.primaryImage.style.width = `${this.elWidth}px`;
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
  
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);

window.theme = {
    showPageTransition: true,
};

(function() {
    window.onpageshow = function() {
        if (window.theme.showPageTransition) {
            var pageTransition = document.querySelector('.PageTransition');

            if (pageTransition) {
                pageTransition.classList.add("transitionHide");
            }
        }

        // When the page is loaded from the cache, we have to reload the cart content
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
    };
})();


//create smooth scroll on click
 
let toTopBtn = document.getElementById('back-top__content--desk');

toTopBtn.addEventListener('click', function(e) {
  e.preventDefault();  
 window.scrollTo({top: 0, behavior: "smooth"});
});

//hide/show button on scroll up/down
let scrollPos = 0;

window.addEventListener('scroll', function(){

  // detects new state and compares it with the new one
  if ((document.body.getBoundingClientRect()).top > scrollPos) {
    document.getElementById('back-top').classList.remove('active');
  } else {
    document.getElementById('back-top').classList.add('active');
  }
  // saves the new position for iteration.
  scrollPos = (document.body.getBoundingClientRect()).top;
});

window.addEventListener('scroll', function() {
    const backTopBtn = document.getElementById('back-top__content--desk');
    if (backTopBtn) {
        if (window.scrollY > 500) {
            backTopBtn.style.bottom = '55px';
        } else {
            backTopBtn.style.bottom = '-100px';
        }
    }
});

// Note: The smooth scroll is already handled by the vanilla JS above (lines 1111-1116)

document.addEventListener('click', function(e) {
    // drawer-page-content click
    if (e.target.matches('.drawer-page-content') || e.target.closest('.drawer-page-content')) {
        if (document.body.classList.contains('overflow-hidden-tablet')) {
            document.querySelector('.sidemenu-close')?.click();
        }
    }

    // closeMenu click
    if (e.target.matches('.closeMenu') || e.target.closest('.closeMenu')) {
        if (document.body.classList.contains('overflow-hidden-tablet')) {
            document.querySelector('.sidemenu-close')?.click();
        }
    }

    // overlay-click
    if (e.target.matches('.overlay-click') || e.target.closest('.overlay-click')) {
        if (document.body.classList.contains('overflow-hidden-mobile')) {
            document.querySelector('.mobile-sidebar__close')?.click();
        }
    }

    // quick-view variant color click
    if (e.target.matches('#quick-view .new_product .variant_color .image_change')) {
        const variantSrc = e.target.getAttribute('data-variant-src');
        if (variantSrc) {
            const quickImg = document.querySelector('.quick_image img');
            if (quickImg) {
                quickImg.setAttribute('srcset', variantSrc);
                quickImg.setAttribute('data-srcset', variantSrc);
            }
        }
    }
});

/* change variant image on variant hover */

document.addEventListener('mouseover', function(e) {
    if (e.target.matches('.color-swatch')) {
        const gridItem = e.target.closest('.grid__item');
        if (gridItem) {
            const cardWrapper = gridItem.querySelector('.card-wrapper');
            if (cardWrapper) cardWrapper.classList.add('Change_variant');
        }
        const changeVariantImg = document.querySelector('.Change_variant .media img');
        const variantImage = e.target.getAttribute('data-variant-image');
        if (changeVariantImg && variantImage) {
            changeVariantImg.setAttribute('srcset', variantImage);
            changeVariantImg.setAttribute('data-srcset', variantImage);
        }
        e.target.classList.add('active');
        const parent = e.target.closest('.ProductItem__ColorSwatchItem');
        if (parent && parent.parentElement) {
            parent.parentElement.querySelectorAll('.ProductItem__ColorSwatchItem').forEach(sibling => {
                if (sibling !== parent) {
                    const swatch = sibling.querySelector('.color-swatch');
                    if (swatch) swatch.classList.remove('active');
                }
            });
        }
    }
});

document.addEventListener('mouseout', function(e) {
    if (e.target.matches('.color-swatch')) {
        const gridItem = e.target.closest('.grid__item');
        if (gridItem) {
            const cardWrapper = gridItem.querySelector('.card-wrapper');
            if (cardWrapper) cardWrapper.classList.remove('Change_variant');
        }
    }
});

document.addEventListener('change', function(e) {
    // quick-view select change
    if (e.target.matches('#quick-view .new_product .sevariant_color .select select')) {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const variantSrc = selectedOption.getAttribute('data-variant-src');
        if (variantSrc) {
            const quickImg = document.querySelector('.quick_image img');
            if (quickImg) {
                quickImg.setAttribute('srcset', variantSrc);
                quickImg.setAttribute('data-srcset', variantSrc);
            }
        }
    }

    // Color radio change
    if (e.target.matches('input[type=radio][name=Color]')) {
        const checkedInput = document.querySelector('.variant_name_color:checked');
        const variantNameEl = document.getElementById('data-variant-name');
        if (checkedInput && variantNameEl) {
            variantNameEl.innerHTML = checkedInput.value;
        }
    }
});
